import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { getMemberDetailByAthleteID } from 'api/userApi';
import routes from 'routes';
import styles from './AthleteActionButtons.module.css';

const AthleteActionButtons = ({ clubId, athleteId, style }) => {
  const navigate = useNavigate();
  const [profileLoading, setProfileLoading] = useState(false);

  const handleResultsClick = () => {
    navigate(routes.admin.members.athleteResults.url(clubId, athleteId));
  };

  const handleProfileClick = async () => {
    setProfileLoading(true);
    try {
      const res = await getMemberDetailByAthleteID(clubId, athleteId);
      if (res.data) {
        navigate(routes.admin.members.showMember.url(clubId, res.data.email));
      }
    } catch (err) {
      console.error('Error fetching member details:', err);
      // You might want to show a toast error here
    } finally {
      setProfileLoading(false);
    }
  };

  return (
    <div className={styles.buttonContainer} style={style}>
      <button
        className={`${styles.actionButton} ${styles.resultsButton}`}
        onClick={handleResultsClick}
      >
        <span className={styles.icon}>📊</span>
        <span className={styles.text}>Results</span>
      </button>

      <button
        className={`${styles.actionButton} ${styles.profileButton}`}
        onClick={handleProfileClick}
        disabled={profileLoading}
      >
        <span className={styles.icon}>👤</span>
        <span className={styles.text}>
          {profileLoading ? 'Loading...' : 'Profile'}
        </span>
      </button>
    </div>
  );
};

AthleteActionButtons.propTypes = {
  clubId: PropTypes.string.isRequired,
  athleteId: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default AthleteActionButtons;
